// Copyright 2026. WebPros International GmbH. All rights reserved.

export const ENABLE_FEATURE = 'features/ENABLE_FEATURE';
export const DISABLE_FEATURE = 'features/DISABLE_FEATURE';

export enum FEATURES {
    NONE = 'none', // Useful for tests. Should not be used in production code.
    BACKUP_RESTORING = 'backup_restoring',
    DIRECT_VNC = 'direct-vnc',
    IGNORE_COMPATIBILITY_CHECK = 'ignore-compatibility-check',
    HIGH_AVAILABILITY_CR = 'high_availability_cr', // todo: SVM2-6974 delete this when high availability for CR is ready
}
